import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 gy-2" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Summary ", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "col-md-6 gy-2" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Processing History", -1)
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "card-text" }
const _hoisted_17 = { class: "list-group list-group-flush" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("view template")
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "card"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Errors ", -1)
const _hoisted_22 = { class: "list-group-item" }
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = { class: "col-md-6 gy-2" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Source Event ", -1)
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = { class: "card-text" }
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Source event")
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createVNode(_component_error_block, { errors: _ctx.errors }, null, 8, ["errors"]),
    (_ctx.event.LatestReceiverStatus)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, [
                  _createVNode("p", _hoisted_8, [
                    _createTextVNode(" Current Status: " + _toDisplayString(_ctx.event.LatestReceiverStatus), 1),
                    _hoisted_9,
                    _createTextVNode(" Actions: " + _toDisplayString(_ctx.event.ReceiverAction.length), 1),
                    _hoisted_10,
                    _createTextVNode(" Internal Duration: " + _toDisplayString(_ctx.getHumanDateDiff(_ctx.event.ReceiverAction[0].Generated, _ctx.event.ReceiverAction[_ctx.event.ReceiverAction.length - 1].Generated)), 1),
                    _hoisted_11,
                    _createTextVNode(" Total Duration: " + _toDisplayString(_ctx.getHumanDateDiff(_ctx.event.SourceEvent.Timestamp, _ctx.event.ReceiverAction[_ctx.event.ReceiverAction.length - 1].Generated)), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("div", _hoisted_15, [
                  _createVNode("p", _hoisted_16, [
                    _createVNode("ul", _hoisted_17, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.event.ReceiverAction, (event, index) => {
                        return (_openBlock(), _createBlock("li", {
                          class: ["list-group-item", ['list-group-item', 'list-group-item-' + (event.Result ? 'success' : (event.ReceiverStatus == 'unsupported' ? 'warning' : 'danger'))]],
                          key: index
                        }, [
                          _createTextVNode(_toDisplayString(event.ReceiverStatus) + " @ " + _toDisplayString(_ctx.getHumanDate(event.Generated)) + " ", 1),
                          (event.TemplateId)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: '/receiver/template/' + event.TemplateId
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_18
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (event.GeneratedArtefacts > 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_19, " " + _toDisplayString(event.GeneratedArtefacts) + " signals", 1))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]),
                    (_ctx.event.LatestReceiverStatus in ['failed', 'unsupported'])
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          class: "btn btn-warning mt-2",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.callRetry()), ["prevent"]))
                        }, "Retry"))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.eventErrors.count > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_20, [
                        _hoisted_21,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventErrors.items, (error, index) => {
                          return (_openBlock(), _createBlock("ul", {
                            class: "list-group list-group-flush",
                            key: index
                          }, [
                            _createVNode("li", _hoisted_22, [
                              _createTextVNode(_toDisplayString(error.Message), 1),
                              _hoisted_23,
                              _createTextVNode(_toDisplayString(error.Data), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  _createVNode("p", _hoisted_28, [
                    _createTextVNode(" Timestamp: " + _toDisplayString(_ctx.getHumanDate(_ctx.event.SourceEvent.Timestamp)), 1),
                    _hoisted_29,
                    _createTextVNode(" Message: " + _toDisplayString(_ctx.event.SourceEvent.Message), 1),
                    _hoisted_30,
                    _createTextVNode(" Activity: " + _toDisplayString(_ctx.event.SourceEvent.Activity.ActivityType), 1),
                    _hoisted_31
                  ]),
                  _createVNode(_component_router_link, {
                    to: '/sheqsy/event/' + _ctx.event.SourceEvent.id,
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_33
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}